export const RedirectTransfacilEmail = (): any => {
  window.location.href = 'http://wa.me/5531982213102';
  return null;
};
